module.exports = __webpack_public_path__ + "static/media/hero-media.6d0e7a99.jpg";